import type { DeepRequired } from '../fixtures.types'

const miDocument: DeepRequired<MiDocumentSummary> = {
  __typename: 'MIDocumentSummary',
  archived: null,
  case_ids: [],
  category: null,
  client_ids: [],
  clients: [],
  created_at: null,
  data_base64: null,
  date_stored: null,
  document_signature: null,
  delete_reason: null,
  document_id: null,
  document_name: null,
  file_type: null,
  other_type: null,
  rendered_mortgage_ids: [],
  rendered_organisation_id: null,
  source: {
    __typename: 'MIDocumentSummarySource',
    first_name: null,
    id: null,
    last_name: null,
    type: null,
  },
  template_id: null,
  template_type: null,
  type: null,
  verification_count: null,
  requirement: null,
  inference_result: null,
  signed_copy: null,
  placeholder: null,
  url: null,
}

export default miDocument
